import type { ModuleDefinition } from '../types';

export const studiesModule: ModuleDefinition = {
  key: 'studies',
  milestone: 'M10',
  network: { path: 'studies', permission: 'study.network.read', labelKey: 'studies' },
  tenant: { path: 'studies', permission: 'study.read', labelKey: 'studies' },
  load: () => import('./StudiesModule'),
};
